import trackCartError from './trackCartError';

/**
 * Updates the cart notification if new cart total is > 0; otherwise removes the
 * cart notification
 *
 * @param {String or Integer} cartTotal New cart total
 * @param {Element} cartEl Cart DOM element
 * @returns
 */
const updateCartNotification = (cartTotal, cartEl) => {
  if (!cartEl) {
    const errorMsg = 'No cart element';
    trackCartError(new Error(errorMsg), errorMsg);
    return;
  }

  const cartElIcon = cartEl.querySelector('.mc-nav-item__content');

  if (!cartElIcon) {
    const errorMsg = 'No cart icon';
    trackCartError(new Error(errorMsg), errorMsg);
    return;
  }

  if (parseInt(cartTotal) === 0) {
    delete cartElIcon.dataset.cart;
  } else if (parseInt(cartTotal) > 0) {
    cartElIcon.dataset.cart = cartTotal;
  } else {
    const errorMsg = 'Invalid cart total';
    trackCartError(new Error(errorMsg), errorMsg, { cartTotal });
    delete cartElIcon.dataset.cart;
  }
};

export default updateCartNotification;
